import clsx from "clsx";
import { useRouter } from "next/router";
import React from "react";
import { useConstructionItemSettings } from "~/hooks/useConstructionItemSettings";
import type { ConstructionItem } from "~/models/ConstructionItem";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionItemSettingList.module.scss";

type Props = {
	constructionItem: ConstructionItem;
};

export function ConstructionItemSettingListRow({ constructionItem }: Props) {
	const router = useRouter();
	const { vendorCompanyId = null } = router.query;
	const { data: constructionItemSettings } =
		useConstructionItemSettings().index(
			vendorCompanyId === null ? null : Number(vendorCompanyId)
		);
	const unitAmount = React.useMemo(
		() =>
			constructionItemSettings?.find(
				(setting) => setting.constructionItemId === constructionItem.id
			)?.unitAmount ?? constructionItem.unitAmount,
		[constructionItem.id, constructionItem.unitAmount, constructionItemSettings]
	);
	return (
		<tr className={clsx(Styles.ListRow)}>
			<td className={clsx(Styles.ListCol)}>{constructionItem.name}</td>
			<td className={clsx(Styles.ListCol, Styles.UnitAMount)}>
				¥{toThousandSeparator(unitAmount)}
			</td>
		</tr>
	);
}
